import React from 'react';
import { COLORS } from '../../constants';
import Donut from './Donut';

export default function MiniMetricTile({ value, total, label }) {
  return (
    <div style={{ flex: 1, background: COLORS.surface, border: `1px solid ${COLORS.line}`, borderRadius: 16, padding: '18px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <div>
        <div style={{ fontSize: 12, color: COLORS.textSecondary, textTransform: 'uppercase', fontWeight: 700, marginBottom: 4 }}>
          {label}
        </div>
        <div style={{ fontSize: 32, fontWeight: 800, color: value > 0 ? COLORS.blue : COLORS.slate, lineHeight: 1 }}>
          {value}
        </div>
      </div>
      <Donut value={value} total={total} size={70} thickness={6} color={COLORS.orange} showPercent />
    </div>
  );
}